import React from 'react';
// @ts-expect-error checkout/react-components
import { LoadingSpinner } from '@checkout/react-components';
// @ts-expect-error type-lazyLoader
import { getLazyLoaderRenderFunction, lazyLoader } from '@/lib';

export const LazyApplePayReceipt = lazyLoader({
  loader: () => import('./ApplePayReceipt'),
  loading: () => <LoadingSpinner />,
  name: 'ApplePayReceipt',
  render: getLazyLoaderRenderFunction({
    componentName: 'ApplePayReceipt',
  }),
});
